import { render, staticRenderFns } from "./CommonValueItem.vue?vue&type=template&id=4e11e8c2&lang=pug&"
import script from "./CommonValueItem.vue?vue&type=script&lang=ts&"
export * from "./CommonValueItem.vue?vue&type=script&lang=ts&"
import style0 from "./CommonValueItem.vue?vue&type=style&index=0&id=4e11e8c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports